import { render, staticRenderFns } from "./RoleCards.vue?vue&type=template&id=2c055cc6&scoped=true&"
import script from "./RoleCards.vue?vue&type=script&lang=js&"
export * from "./RoleCards.vue?vue&type=script&lang=js&"
import style0 from "./RoleCards.vue?vue&type=style&index=0&id=2c055cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c055cc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
